import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccount } from 'wagmi';
import { useContract } from '../hooks/useContract';
import './CreatePage.css';

export function CreatePage() {
  const { address, isConnected } = useAccount();
  const { createPage, loading, error } = useContract();
  const navigate = useNavigate();

  const [secretText, setSecretText] = useState('');
  const [unlockPrice, setUnlockPrice] = useState('');
  const [password, setPassword] = useState('');
  const [usePassword, setUsePassword] = useState(false);
  const [usePayment, setUsePayment] = useState(true);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!secretText.trim()) {
      alert('Please enter your secret text');
      return;
    }

    if (!usePayment && !usePassword) {
      alert('Please set at least one unlock method (payment or password)');
      return;
    }

    if (usePayment && (!unlockPrice || parseFloat(unlockPrice) <= 0)) {
      alert('Please enter a valid unlock price');
      return;
    }

    if (usePassword && !password) {
      alert('Please enter a password');
      return;
    }

    const pageId = await createPage(
      secretText,
      usePayment ? unlockPrice : '0',
      usePassword ? password : ''
    );

    if (pageId !== null) {
      alert(`Secret page #${pageId} created successfully!`);
      navigate('/book');
    }
  };

  if (!isConnected || !address) {
    navigate('/');
    return null;
  }

  return (
    <div className="create-page">
      <div className="create-container">
        <div className="create-header">
          <h1 className="create-title">Create Secret Page</h1>
          <p className="create-subtitle">
            Write your secret and set how others can unlock it
          </p>
        </div>

        <form className="create-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Your Secret</label>
            <textarea
              className="secret-textarea"
              placeholder="Write your secret here..."
              value={secretText}
              onChange={(e) => setSecretText(e.target.value)}
              rows={8}
              maxLength={500}
            />
            <div className="char-count">{secretText.length} / 500</div>
          </div>

          <div className="unlock-methods">
            <h3 className="methods-title">Unlock Methods</h3>
            <p className="methods-subtitle">Choose at least one way for others to unlock your secret</p>

            <div className="method-option">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={usePayment}
                  onChange={(e) => setUsePayment(e.target.checked)}
                />
                <span>Pay with cBTC</span>
              </label>
              {usePayment && (
                <div className="method-input">
                  <input
                    type="number"
                    step="0.00001"
                    min="0.00001"
                    placeholder="0.00001"
                    value={unlockPrice}
                    onChange={(e) => setUnlockPrice(e.target.value)}
                    className="price-input"
                  />
                  <span className="input-suffix">cBTC</span>
                </div>
              )}
            </div>

            <div className="method-option">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={usePassword}
                  onChange={(e) => setUsePassword(e.target.checked)}
                />
                <span>Unlock with Password</span>
              </label>
              {usePassword && (
                <div className="method-input">
                  <input
                    type="password"
                    placeholder="Enter password..."
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="password-input-field"
                  />
                </div>
              )}
            </div>
          </div>

          {error && <div className="error-box">{error}</div>}

          <div className="form-actions">
            <button
              type="button"
              className="btn-cancel"
              onClick={() => navigate('/profile')}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-create"
              disabled={loading}
            >
              {loading ? 'Creating...' : '📝 Create Page'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
